export const NavOptions = [
    {
        option: "USER PROFILE",
        path: "/your-account"
    },
    {
        option: "PRODUCTS",
        path: "/products"
    },
    {
        option: "COMPLAINT FORM",
        path: "/complaint-form"
    },
    {
        option: "FRANCHISE OPPORTUNITY",
        path: "/franchise-opportunity"
    },
    {
        option: "REVIEWS",
        path: "/reviews"
    },
    {
        option: "JOBS OPPORTUNITIES",
        path: "/jobs-opportunities"
    },
    {
        option:  "PRIVACY COMMITMENT",
        path: "/privacy-policy"
    },
       
]

export const CustomerCareOptions = [
    {
        option:  "HELP CENTER",
        path: "/help-center"
    },
    {
        option:  "HOW TO BUY",
        path: "/how-to-buy"
    },
    {
        option:  "CORPORATE & BULK PURCHASING",
        path: "/corporate-bulk-purchasing"
    },
    {
        option:  "RETURNS & REFUNDS",
        path: "/returns-refunds"
    },
    {
        option:  "CONTACT US",
        path: "/contact-us"
    },
    {
        option:  "PURCHASE PROTECTION",
        path: "/purchase-protection"
    },   
]